<template>
	<div class="w-full">
		<div class="flex justify-between items-center border-b mb-4">
			<h2 class="text-xl font-light sm:text-2xl md:text-4xl">Education</h2>
			<button @click="addEducation" class="bg-blue-dark text-white py-1 px-2 rounded block md:py-2 md:px-4">Add Education</button>
		</div>

		<form v-for="(v, index) in $v.education.$each.$iter" :key="`education-${index}`" class="mb-8 ml-2 pl-4 border-l-2 py-2" :class="v.$invalid && $v.$dirty ? 'border-red' : 'border-grey'">
			<div class="flex items-center mb-4 justify-between">
				<h3 class="text-black font-semibold">Education #{{ parseInt(index) + 1 }}</h3>
				<button type="button" @click="removeEducation(index)" :class="{ 'opacity-50 cursor-not-allowed': education.length === 1 }" class="bg-red text-white px-4 ml-2 rounded h-8">Remove</button>
			</div>

			<div class="flex items-center">
				<label :for="`type-${index}`" class="mr-2 flex-no-shrink">Type<span class="hidden sm:inline"> of Study</span>*</label>
				<select v-model="v.type.$model" autocomplete="off" :class="v.type.$invalid && $v.$dirty ? 'border-red' : ''" :id="`type-${index}`" class="bg-white shadow-inner border rounded px-2 h-8 w-full">
					<option value=""></option>
					<option value="High School">High School</option>
					<option value="College">College</option>
					<option value="Graduate">Graduate</option>
					<option value="Other">Other Education or Training</option>
				</select>
			</div>

			<div class="mt-4">
				<p>Have you completed this education or training?*</p>
				<div class="flex pl-4">
					<div class="flex items-center mr-4">
						<input type="radio" v-model="v.complete.$model" autocomplete="off" :name="`complete-${index}`" :value="true" :id="`complete-${index}-yes`"><label :id="`complete-${index}-yes`" class="ml-1">Yes</label>
					</div>
					<div class="flex items-center">
						<input type="radio" v-model="v.complete.$model" autocomplete="off" :name="`complete-${index}`" :value="false" :id="`complete-${index}-no`"><label :id="`complete-${index}-no`" class="ml-1">No</label>
					</div>
					<p class="text-xs ml-auto text-red font-bold tracking-wide" v-if="v.complete.$invalid && $v.$dirty">Required</p>
				</div>
			</div>

			<div class="flex flex-col mt-4">
				<label :for="`name-${index}`" class="uppercase text-xs pl-2 font-semibold">Name*</label>
				<input type="text" v-model="v.name.$model" :class="v.name.$invalid && $v.$dirty ? 'border-red' : ''" :id="`name-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.name.$invalid && $v.$dirty">Required</p>
			</div>

			<div class="flex justify-between -mx-2 flex-col sm:flex-row">
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`city-${index}`" class="uppercase text-xs pl-2 font-semibold">City*</label>
					<input type="text" v-model="v.city.$model" autocomplete="off" :class="v.city.$invalid && $v.$dirty ? 'border-red' : ''" :id="`city-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.city.$invalid && $v.$dirty">Required</p>
				</div>
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`state-${index}`" class="uppercase text-xs pl-2 font-semibold">State*</label>
					<select v-model="v.state.$model" autocomplete="off" :class="v.state.$invalid && $v.$dirty ? 'border-red' : ''" :id="`state-${index}`" class="bg-white shadow-inner border rounded px-2 h-8 w-full">
						<option value=""></option>
						<option value="AL">Alabama</option>
						<option value="AK">Alaska</option>
						<option value="AZ">Arizona</option>
						<option value="AR">Arkansas</option>
						<option value="CA">California</option>
						<option value="CO">Colorado</option>
						<option value="CT">Connecticut</option>
						<option value="DE">Delaware</option>
						<option value="DC">District Of Columbia</option>
						<option value="FL">Florida</option>
						<option value="GA">Georgia</option>
						<option value="HI">Hawaii</option>
						<option value="ID">Idaho</option>
						<option value="IL">Illinois</option>
						<option value="IN">Indiana</option>
						<option value="IA">Iowa</option>
						<option value="KS">Kansas</option>
						<option value="KY">Kentucky</option>
						<option value="LA">Louisiana</option>
						<option value="ME">Maine</option>
						<option value="MD">Maryland</option>
						<option value="MA">Massachusetts</option>
						<option value="MI">Michigan</option>
						<option value="MN">Minnesota</option>
						<option value="MS">Mississippi</option>
						<option value="MO">Missouri</option>
						<option value="MT">Montana</option>
						<option value="NE">Nebraska</option>
						<option value="NV">Nevada</option>
						<option value="NH">New Hampshire</option>
						<option value="NJ">New Jersey</option>
						<option value="NM">New Mexico</option>
						<option value="NY">New York</option>
						<option value="NC">North Carolina</option>
						<option value="ND">North Dakota</option>
						<option value="OH">Ohio</option>
						<option value="OK">Oklahoma</option>
						<option value="OR">Oregon</option>
						<option value="PA">Pennsylvania</option>
						<option value="RI">Rhode Island</option>
						<option value="SC">South Carolina</option>
						<option value="SD">South Dakota</option>
						<option value="TN">Tennessee</option>
						<option value="TX">Texas</option>
						<option value="UT">Utah</option>
						<option value="VT">Vermont</option>
						<option value="VA">Virginia</option>
						<option value="WA">Washington</option>
						<option value="WV">West Virginia</option>
						<option value="WI">Wisconsin</option>
						<option value="WY">Wyoming</option>
					</select>
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.state.$invalid && $v.$dirty">Required</p>
				</div>
			</div>

			<div class="flex justify-between -mx-2 flex-col sm:flex-row">
				<div class="mx-2 flex flex-col sm:w-32 mt-4">
					<label :for="`years-${index}`" class="uppercase text-xs pl-2 font-semibold">Years Attended*</label>
					<input type="text" v-model="v.years.$model" autocomplete="off" :class="v.years.$invalid && $v.$dirty ? 'border-red' : ''" :id="`years-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.years.$invalid && $v.$dirty">Required</p>
				</div>
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`field-${index}`" class="uppercase text-xs pl-2 font-semibold">Field of Study</label>
					<input type="text" v-model="v.field.$model" autocomplete="off" :class="v.field.$invalid && $v.$dirty ? 'border-red' : ''" :id="`field-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.field.$invalid && $v.$dirty">Required</p>
				</div>
			</div>
		</form>

		<div v-if="education.length === 0" class="flex">
			<div class="mx-auto px-4 bg-red-lightest border-red-dark border-2 text-center py-2 rounded mx-auto">
				<p>Add education using the button above.<br>At least one is required.</p>
			</div>
		</div>

		<div class="flex justify-between items-center border-b mt-8 mb-4">
			<h2 class="text-xl font-light sm:text-2xl md:text-4xl">Employment</h2>
			<button @click="addEmployment" class="bg-blue-dark text-white py-1 px-2 rounded block md:py-2 md:px-4">Add Employment</button>
		</div>

		<form v-for="(v, index) in $v.employment.$each.$iter" :key="`employment-${index}`" class="mb-8 ml-2 pl-4 border-l-2 py-2" :class="v.$invalid && $v.$dirty ? 'border-red' : 'border-grey'">
			<div class="flex items-center mb-4 justify-between">
				<h3 class="text-black font-semibold">Employer #{{ parseInt(index) + 1 }}</h3>
				<button type="button" @click="removeEmployment(index)" class="bg-red text-white px-4 ml-2 rounded h-8">Remove</button>
			</div>

			<div class="flex flex-col">
				<label :for="`name-${index}`" class="uppercase text-xs pl-2 font-semibold">Name*</label>
				<input type="text" v-model="v.name.$model" autocomplete="off" :class="v.name.$invalid && $v.$dirty ? 'border-red' : ''" :id="`name-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
				<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.name.$invalid && $v.$dirty">Required</p>
			</div>

			<div class="flex justify-between -mx-2 flex-col sm:flex-row">
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`city-${index}`" class="uppercase text-xs pl-2 font-semibold">City*</label>
					<input type="text" autocomplete="off" v-model="v.city.$model" :class="v.city.$invalid && $v.$dirty ? 'border-red' : ''" :id="`city-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.city.$invalid && $v.$dirty">Required</p>
				</div>
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`state-${index}`" class="uppercase text-xs pl-2 font-semibold">State*</label>
					<select v-model="v.state.$model" autocomplete="off" :class="v.state.$invalid && $v.$dirty ? 'border-red' : ''" :id="`state-${index}`" class="bg-white shadow-inner border rounded px-2 h-8 w-full">
						<option value=""></option>
						<option value="AL">Alabama</option>
						<option value="AK">Alaska</option>
						<option value="AZ">Arizona</option>
						<option value="AR">Arkansas</option>
						<option value="CA">California</option>
						<option value="CO">Colorado</option>
						<option value="CT">Connecticut</option>
						<option value="DE">Delaware</option>
						<option value="DC">District Of Columbia</option>
						<option value="FL">Florida</option>
						<option value="GA">Georgia</option>
						<option value="HI">Hawaii</option>
						<option value="ID">Idaho</option>
						<option value="IL">Illinois</option>
						<option value="IN">Indiana</option>
						<option value="IA">Iowa</option>
						<option value="KS">Kansas</option>
						<option value="KY">Kentucky</option>
						<option value="LA">Louisiana</option>
						<option value="ME">Maine</option>
						<option value="MD">Maryland</option>
						<option value="MA">Massachusetts</option>
						<option value="MI">Michigan</option>
						<option value="MN">Minnesota</option>
						<option value="MS">Mississippi</option>
						<option value="MO">Missouri</option>
						<option value="MT">Montana</option>
						<option value="NE">Nebraska</option>
						<option value="NV">Nevada</option>
						<option value="NH">New Hampshire</option>
						<option value="NJ">New Jersey</option>
						<option value="NM">New Mexico</option>
						<option value="NY">New York</option>
						<option value="NC">North Carolina</option>
						<option value="ND">North Dakota</option>
						<option value="OH">Ohio</option>
						<option value="OK">Oklahoma</option>
						<option value="OR">Oregon</option>
						<option value="PA">Pennsylvania</option>
						<option value="RI">Rhode Island</option>
						<option value="SC">South Carolina</option>
						<option value="SD">South Dakota</option>
						<option value="TN">Tennessee</option>
						<option value="TX">Texas</option>
						<option value="UT">Utah</option>
						<option value="VT">Vermont</option>
						<option value="VA">Virginia</option>
						<option value="WA">Washington</option>
						<option value="WV">West Virginia</option>
						<option value="WI">Wisconsin</option>
						<option value="WY">Wyoming</option>
					</select>
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.state.$invalid && $v.$dirty">Required</p>
				</div>
			</div>
			
			<div class="flex justify-between -mx-2">
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`title-${index}`" class="uppercase text-xs pl-2 font-semibold">Title*</label>
					<input type="text" autocomplete="off" v-model="v.title.$model" :class="v.title.$invalid && $v.$dirty ? 'border-red' : ''" :id="`title-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.title.$invalid && $v.$dirty">Required</p>
				</div>
			</div>

			<div class="flex justify-between -mx-2 flex-col sm:flex-row">
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`start-${index}`" class="uppercase text-xs pl-2 font-semibold">Start Date*</label>
					<input type="text" autocomplete="off" v-model="v.start.$model" :class="v.start.$invalid && $v.$dirty ? 'border-red' : ''" :id="`start-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.start.$invalid && $v.$dirty">Required</p>
				</div>
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`end-${index}`" class="uppercase text-xs pl-2 font-semibold">End Date</label>
					<input type="text" autocomplete="off" v-model="v.end.$model" :class="v.end.$invalid && $v.$dirty ? 'border-red' : ''" :id="`end-${index}`" class="shadow-inner border rounded px-2 h-8 w-full">
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.end.$invalid && $v.$dirty"></p>
				</div>
			</div>
			
			<div class="flex justify-between -mx-2">
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`responsibilities-${index}`" class="uppercase text-xs pl-2 font-semibold">What responsibilities did you have?*</label>
					<textarea type="text" autocomplete="off" v-model="v.responsibilities.$model" :class="v.responsibilities.$invalid && $v.$dirty ? 'border-red' : ''" :id="`responsibilities-${index}`" class="shadow-inner border rounded px-2 py-1 h-16 w-full"></textarea>
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.responsibilities.$invalid && $v.$dirty">Required</p>
				</div>
			</div>
			
			<div class="flex justify-between -mx-2">
				<div class="mx-2 flex flex-col flex-1 mt-4">
					<label :for="`reason-${index}`" class="uppercase text-xs pl-2 font-semibold">What was your reason for leaving?*</label>
					<textarea type="text" autocomplete="off" v-model="v.reason.$model" :class="v.reason.$invalid && $v.$dirty ? 'border-red' : ''" :id="`reason-${index}`" class="shadow-inner border rounded px-2 py-1 h-16 w-full"></textarea>
					<p class="text-xs pl-2 text-red font-bold tracking-wide" v-if="v.reason.$invalid && $v.$dirty">Required</p>
				</div>
			</div>
		</form>

		<div v-if="employment.length === 0" class="flex">
			<div class="mx-auto px-4 bg-yellow-lightest border-yellow-dark border-2 text-center py-2 rounded mx-auto">
				<p>Add employment using the button above. Please include at least your last three if you can.</p>
			</div>
		</div>

		<div class="mt-8 flex text-lg justify-between">
			<button @click="submit" :class="{ 'opacity-50 cursor-not-allowed' : $v.$invalid && $v.$dirty }" class="ml-auto font-semibold bg-green-dark text-white py-2 px-4 rounded ml-4 block">Continue</button>
		</div>
	</div>
</template>

<script>
	import { minLength, required } from 'vuelidate/lib/validators'

	export default {
		created() {
			this.education = this.$store.state.form.experience.education
			this.employment = this.$store.state.form.experience.employment

			if (this.education.length === 0) {
				this.addEducation()
			}
		},

		data() {
			return {
				submitting: false,
				
				education: [],
				employment: [],
			}
		},

		validations: {
			education: {
				minLength: minLength(1),

				$each: {
					type: { required },
					complete: { required },
					name: { required },
					city: { required },
					state: { required },
					years: { required },
					field: {},
				},
			},

			employment: {
				$each: {
					name: { required },
					city: { required },
					state: { required },
					title: { required },
					start: { required },
					end: {},
					responsibilities: { required },
					reason: { required },
				},
			},
		},

		methods: {
			addEducation() {
				this.education.push({
					type: '',
					complete: '',
					name: '',
					city: '',
					state: '',
					years: '',
					field: '',
				})
			},

			addEmployment() {
				this.employment.push({
					name: '',
					city: '',
					state: '',
					title: '',
					start: '',
					end: '',
					responsibilities: '',
					reason: '',
				})
			},

			removeEducation(index) {
				if (this.education.length === 1) {
					return
				}

				this.education = [
					...this.education.slice(0, index),
					...this.education.slice(index + 1)
				]
			},

			removeEmployment(index) {
				this.employment = [
					...this.employment.slice(0, index),
					...this.employment.slice(index + 1)
				]
			},

			submit() {
				if (this.$v.$invalid || this.submitting) {
					this.$v.$touch()
					return
				}

				this.submitting = true

				this.$store.commit('setExperience', {
					education: this.education,
					employment: this.employment,
				})

				this.$router.push('/review')
			}
		},
	}
</script>
